import React, { Component } from 'react';
import { isLoaded, isEmpty } from 'react-redux-firebase';
import { Link } from 'react-router-dom';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import Strings from 'components/Strings';
import user from 'images/user.svg';
import './auth.css';

class Auth extends Component {
  state = {
    authedMenuEl: null,
    unauthedMenuEl: null
  };

  handleAuthedClick = event => {
    this.setState({ authedMenuEl: event.currentTarget });
  }

  handleUnauthedClick = event => {
    this.setState({ unauthedMenuEl: event.currentTarget });
  }

  handleMenuClose = () => {
    this.setState({ authedMenuEl: null, unauthedMenuEl: null });
  }

  handleSignIn = () => {
    this.handleMenuClose();
    this.props.firebase.login({
      provider: 'google',
      type: 'popup'
    });
  }

  handleSignOut = () => {
    this.handleMenuClose();
    this.props.firebase.logout();
  }

  renderCurrentUser() {
    const { profile } = this.props;
    const { authedMenuEl } = this.state;
  
    return (
      <div>
        <button
          className="Auth-user authed"
          aria-owns={ authedMenuEl ? 'authed-menu' : null }
          aria-haspopup="true"
          onClick={ this.handleAuthedClick }>
          <img src={ profile.avatarUrl } alt="Profile" />
        </button>

        <Popper open={ Boolean(authedMenuEl) } anchorEl={ authedMenuEl }>
          <Paper>
            <ClickAwayListener onClickAway={ this.handleMenuClose }>
              <MenuList id="authed-menu">
                <MenuItem onClick={ this.handleMenuClose }><Link to='/willBuy'><Strings label="gifts_i_will_buy" /></Link></MenuItem>
                <MenuItem onClick={ this.handleMenuClose }><Link to='/bought'><Strings label="gifts_i_bought" /></Link></MenuItem>
                <MenuItem onClick={ this.handleSignOut }><Strings label="sign_out" /></MenuItem>
              </MenuList>
          </ClickAwayListener>
          </Paper>
        </Popper>
      </div>
    )
  }

  renderSignIn() {
    const { unauthedMenuEl } = this.state;

    return (
      <div>
        <button
          className="Auth-user unauthed"
          aria-owns={ unauthedMenuEl ? 'unauthed-menu' : null }
          aria-haspopup="true"
          onClick={ this.handleUnauthedClick }>
          <img src={ user } alt={ <Strings label="profile_picture" /> } />
        </button>

        <Popper open={ Boolean(unauthedMenuEl) } anchorEl={ unauthedMenuEl }>
          <Paper>
            <ClickAwayListener onClickAway={ this.handleMenuClose }>
              <MenuList id="unauthed-menu">
                <MenuItem onClick={ this.handleSignIn }><Strings label="sign_in" /></MenuItem>
              </MenuList>
          </ClickAwayListener>
          </Paper>
        </Popper>
      </div>
    )
  }

  renderEmpty() {
    return ''
  }

  render() {
    const { profile } = this.props

    return (
      <div className="Auth">
        {
          isLoaded(profile)
          ? isEmpty(profile)
            ? this.renderSignIn()
            : this.renderCurrentUser()
          : this.renderEmpty()
        }
      </div>
    );
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js